import React from "react";
import {useStoreTotalsContextMenu} from "./StoreTotalsContextMenuProvider";

export const StoreTotalsCellContextMenu = ({trigger, className, testId, children}) => {
    const openMenu = useStoreTotalsContextMenu();

    return <div className={className} data-testid={testId} onContextMenu={(event) => openMenu(trigger, event)}>
        {children}
    </div>;
};
